import { render } from "./linkedin.svg?vue&type=template&id=66616b7a"
const script = {}
script.render = render

export default script